import { BlogSection } from '@/components/ui/blog-section';
import { blogPosts } from './blogData';
import Footer from '@/components/Footer';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useBreadcrumbJsonLd } from '@/hooks/useBreadcrumbJsonLd';
import { useBlogListJsonLd } from '@/hooks/useBlogListJsonLd';

const BlogPage = () => {
    useDocumentMeta({
        title: 'Blog | Antz.ai — AI, Manufacturing Intelligence & Enterprise Automation',
        description:
            'Insights on manufacturing intelligence, agentic AI, document processing, enterprise search, and mortgage automation from the Antz AI team.',
    });
    useBreadcrumbJsonLd([
        { name: 'Home', href: '/' },
        { name: 'Blog', href: '/blog' },
    ]);
    useBlogListJsonLd(
        blogPosts.map((p) => ({
            title: p.title,
            slug: p.slug,
            image: p.image,
            datePublished: p.createdAt,
        })),
    );

    return (
        <div className="min-h-screen bg-background text-foreground">
            {/* Positioning block */}
            <div className="relative pt-28 pb-10">
                <div className="mx-auto max-w-5xl px-4">
                    <p className="text-xs font-medium uppercase tracking-widest text-primary mb-3">
                        Manufacturing &middot; Mortgage &middot; AI R&D
                    </p>
                    <h1 className="font-mono text-4xl font-bold tracking-wide mb-3">
                        The Ant-thology
                    </h1>
                    <p className="text-muted-foreground text-base max-w-2xl leading-relaxed">
                        We dig deep into AI so you don't have to. Our team researches, tests, and builds the right tools for manufacturing intelligence and mortgage automation, so every decision your team makes is backed by data, not guesswork.
                    </p>
                </div>
            </div>

            <div className="relative pb-16">
                <BlogSection
                    posts={blogPosts}
                    showHeader={false}
                />
            </div>
            <Footer />
        </div>
    );
};

export default BlogPage;
